import React, { FC } from 'react';
import { Control } from 'react-hook-form';
import { OrderProperty } from 'types/order';

import { TabSubdivisionScene } from './tab-subdivision-scene';

type TabSubdivisionProps = {
  control: Control<Omit<OrderProperty, 'loans'>>
}

export const TabSubdivision: FC<TabSubdivisionProps> = ({ control }) => (
  <TabSubdivisionScene
    control={control}
  />
);
